<template>
  <div class="tabs tabs-v3 is-small general-configuration-tabs entity-tabs">
    <ul>
      <li
        v-for="tab in tabs"
        :key="tab.key"
        :class="{ 'active-customer': activeKey === tab.key }"
      >
        <a class="tab" @click="$emit('change', tab)">{{ tab.label }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'EntityTabs',
  props: {
    tabs: {
      type: Array,
      required: true
    },
    activeKey: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.entity-tabs {
  margin-bottom: 1rem;
}
</style>
